import { render, staticRenderFns } from "./TableQuery.vue?vue&type=template&id=13f1196e&scoped=true"
import script from "./TableQuery.vue?vue&type=script&lang=js"
export * from "./TableQuery.vue?vue&type=script&lang=js"
import style0 from "./TableQuery.vue?vue&type=style&index=0&id=13f1196e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f1196e",
  null
  
)

export default component.exports